function DTWishlist() {

  const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
  const LOCAL_STORAGE_DELIMITER = ',';
  const BUTTON_ACTIVE_CLASS = 'added';
  const GRID_LOADED_CLASS = 'loaded';

  const selectors = {
    button: '[button-wishlist]',
    grid: '[grid-wishlist]',
    productCard: '.wishlist__grid-item',
  };


  // -------------------------------------------------------------------------
  // iOS Detection
  // -------------------------------------------------------------------------

  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (
      navigator.platform === 'MacIntel' &&
      navigator.maxTouchPoints > 1
    );


  document.addEventListener('DOMContentLoaded', () => {
    initButtons();
    initGrid();
  });


  document.addEventListener(
    'shopify-wishlist:updated',
    (event) => {
      initGrid();
      wishListCount();
    }
  );

  window.addEventListener('storage', (event) => {
    if (event.key === LOCAL_STORAGE_WISHLIST_KEY) {
      wishListCount();
      initButtons();
    }
  });


  // -------------------------------------------------------------------------
  // Fetch Wishlist Product Card
  // -------------------------------------------------------------------------

  const fetchProductCardHTML = async (handle) => {

    const productTileTemplateUrl =
      `/products/${handle}?view=card`;

    try {

      const res =
        await fetch(productTileTemplateUrl);

      const text =
        await res.text();

      const parser =
        new DOMParser();

      const htmlDocument =
        parser.parseFromString(
          text,
          'text/html'
        );

      const productCard =
        htmlDocument.documentElement
          .querySelector(
            selectors.productCard
          );

      return productCard
        ? productCard.outerHTML
        : '';

    } catch (err) {

      console.error(
        `[Shopify Wishlist] Failed to load content for handle: ${handle}`,
        err
      );

      return '';

    }

  };


  // -------------------------------------------------------------------------
  // Setup Grid
  // -------------------------------------------------------------------------

  const setupGrid = async (grid) => {

    const wishlist =
      getWishlist();

    const requests =
      wishlist.map(fetchProductCardHTML);

    const responses =
      await Promise.all(requests);

    const wishlistProductCards =
      responses.join('');

    grid.innerHTML =
      wishlistProductCards;

    grid.classList.add(
      GRID_LOADED_CLASS
    );

    initButtons();


    const event =
      new CustomEvent(
        'shopify-wishlist:init-product-grid',
        {
          detail: {
            wishlist: wishlist
          }
        }
      );

    document.dispatchEvent(event);

  };


  // -------------------------------------------------------------------------
  // Setup Wishlist Buttons
  // -------------------------------------------------------------------------

  const setupButtons = (buttons) => {

    buttons.forEach((button) => {

      const productHandle =
        button.dataset.productHandle ||
        false;


      if (!productHandle) {

        console.error(
          '[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.'
        );

        return;

      }


      if (
        wishlistContains(productHandle)
      ) {

        button.classList.add(
          BUTTON_ACTIVE_CLASS
        );

      }


      // ---------------------------------------------------------------
      // Normal Click
      // ---------------------------------------------------------------

      button.addEventListener(
        'click',
        (event) => {

          event.preventDefault();

          updateWishlist(
            productHandle
          );

          button.classList.toggle(
            BUTTON_ACTIVE_CLASS
          );

        }
      );


      // ---------------------------------------------------------------
      // iOS Touch Fallback
      // ---------------------------------------------------------------

      if (isIOS) {

        let touchHandled = false;


        button.addEventListener(
          'touchstart',
          () => {

            touchHandled = false;

          },
          {
            passive: true
          }
        );


        button.addEventListener(
          'touchend',
          (event) => {

            if (touchHandled) {
              return;
            }

            touchHandled = true;


            event.preventDefault();


            // Directly execute Wishlist logic
            // instead of relying on synthetic click

            updateWishlist(
              productHandle
            );

            button.classList.toggle(
              BUTTON_ACTIVE_CLASS
            );


            setTimeout(() => {

              touchHandled = false;

            }, 700);

          },
          {
            passive: false
          }
        );

      }

    });

  };


  // -------------------------------------------------------------------------
  // Initialize Grid
  // -------------------------------------------------------------------------

  const initGrid = () => {

    const grid =
      document.querySelector(
        selectors.grid
      ) || false;


    if (grid) {
      setupGrid(grid);
    }


    wishListCount();

  };


  // -------------------------------------------------------------------------
  // Initialize Buttons
  // -------------------------------------------------------------------------

  const initButtons = () => {

    const buttons =
      document.querySelectorAll(
        selectors.button
      ) || [];


    if (buttons.length) {

      setupButtons(buttons);

    } else {

      return;

    }


    const event =
      new CustomEvent(
        'shopify-wishlist:init-buttons',
        {
          detail: {
            wishlist: getWishlist()
          }
        }
      );


    document.dispatchEvent(event);

  };


  // -------------------------------------------------------------------------
  // Get Wishlist
  // -------------------------------------------------------------------------

  const getWishlist = () => {

    const wishlist =
      localStorage.getItem(
        LOCAL_STORAGE_WISHLIST_KEY
      ) || false;


    if (wishlist) {

      return wishlist.split(
        LOCAL_STORAGE_DELIMITER
      );

    }


    return [];

  };


  // -------------------------------------------------------------------------
  // Set Wishlist
  // -------------------------------------------------------------------------

  const setWishlist = (array) => {

    const wishlist =
      array.join(
        LOCAL_STORAGE_DELIMITER
      );


    if (array.length) {

      localStorage.setItem(
        LOCAL_STORAGE_WISHLIST_KEY,
        wishlist
      );

    } else {

      localStorage.removeItem(
        LOCAL_STORAGE_WISHLIST_KEY
      );

    }


    const event =
      new CustomEvent(
        'shopify-wishlist:updated',
        {
          detail: {
            wishlist: array
          }
        }
      );


    document.dispatchEvent(event);


    return wishlist;

  };


  // -------------------------------------------------------------------------
  // Update Wishlist
  // -------------------------------------------------------------------------

  const updateWishlist = (handle) => {

    const wishlist =
      getWishlist();

    const indexInWishlist =
      wishlist.indexOf(handle);

    let count = 0;


    if (indexInWishlist === -1) {

      wishlist.push(handle);

      count = 1;

    } else {

      wishlist.splice(
        indexInWishlist,
        1
      );

      count = -1;

    }


    setWishlist(wishlist);

    wishListCount();

  };


  // -------------------------------------------------------------------------
  // Check Wishlist
  // -------------------------------------------------------------------------

  const wishlistContains = (handle) => {

    const wishlist =
      getWishlist();

    return wishlist.includes(handle);

  };


  // -------------------------------------------------------------------------
  // Reset Wishlist
  // -------------------------------------------------------------------------

  const resetWishlist = () => {

    return setWishlist([]);

  };


  // -------------------------------------------------------------------------
  // Wishlist Count
  // -------------------------------------------------------------------------

  const wishListCount = (handle) => {

    const currentCount =
      getWishlist().length;

    const wishCounts =
      document.querySelectorAll(
        '.wishlist-count-bubble'
      );

    wishCounts.forEach(wishCount => {
      const countSpan =
        wishCount.querySelector('span');
      if (countSpan) {
        countSpan.innerHTML =
          currentCount;
      }
    });

    const wishContainer =
      document.getElementById(
        'wishlist'
      );

    if (currentCount === 0) {

      document
        .querySelectorAll(
          '.dtxc-wishlist-count, .wishlist-count-bubble'
        )
        .forEach(
          countBubble => {
            countBubble.style.display =
              'none';
          }
        );

      setTimeout(() => {

        if (!wishContainer) {
          return;
        }

        if (
          wishContainer.querySelector(
            '.wishlist__grid'
          )
        ) {

          wishContainer
            .querySelector(
              '.wishlist__grid'
            )
            .innerHTML =
            'Your wishlist looks empty';

          wishContainer
            .querySelector(
              '.wishlist__grid'
            )
            .classList.add(
              'empty-list'
            );

        } else {

          console.error(
            'Error: wishlist container or grid not found'
          );

        }

      }, 1000);

    } else {

      document
        .querySelectorAll(
          '.dtxc-wishlist-count, .wishlist-count-bubble'
        )
        .forEach(
          countBubble => {
            countBubble.style.display =
              'flex';
          }
        );

    }


    // ---------------------------------------------------------------
    // Footer Wishlist Heart
    // ---------------------------------------------------------------

    var wishlistBubble =
      document.getElementById(
        'dtxc-wishlistBubble'
      );

    var footerHeart =
      document.getElementById(
        'footerHeart'
      );


    if (
      wishlistBubble &&
      footerHeart
    ) {

      footerHeart.innerHTML = '';

      var clone =
        wishlistBubble.cloneNode(true);

      footerHeart.appendChild(
        clone
      );

    }

  };


  // -------------------------------------------------------------------------
  // Initial Calls
  // -------------------------------------------------------------------------

  initButtons();
  initGrid();

}


// ---------------------------------------------------------------------------
// Start Wishlist
// ---------------------------------------------------------------------------

document.addEventListener(
  'DOMContentLoaded',
  () => {
    DTWishlist();
  }
);